import { render, staticRenderFns } from "./SlideLayers.vue?vue&type=template&id=0061af1f"
import script from "./SlideLayers.vue?vue&type=script&lang=js"
export * from "./SlideLayers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports